import { Form } from 'react-bootstrap';

const UsernameField = ({ labelText, placeholder, inputValue, onChange, inputEditable }) => {

    return (
        <Form.Group className="mb-2" controlId="username">
          <Form.Label>{labelText}</Form.Label>
          <Form.Control
            type="text"
            disabled={inputEditable}            
            value={inputValue}
            placeholder={placeholder}
            onChange={onChange}
            required
          />
        </Form.Group>
    )
}

export default UsernameField